import { set, get } from '../api/localStore';

export function saveCurrentRoute(route) {
    set('route', route);
}

export function getLastSavedRoute() {
    return get('route');
}


// WEBPACK FOOTER //
// ./app/util/routeHelper.js